<!-- 簽名模板 -->
<template>
  <div id="Signature">
    <h6>
      請把民宿當成您自己的家一樣愛護，並期盼您常回來看我們！謝謝您的合作，祝旅途平安順心！
    </h6>
    <p><img src="@/assets/signature.png" alt="民宿主人" /></p>
  </div>
</template>

<script>
export default {
  name: 'Signature'
}
</script>

<style scoped lang="scss">
/*-----------------------------------------------------------
！手機版！！手機版！！手機版！！小於576px！！手機版！！手機版！！手機版！
------------------------------------------------------------*/
@media screen and (max-width: 576px) {
  #Signature {
    h6 {
      padding: 20px;
    }
    p {
      text-align: center;
      margin-bottom: 25px;
      img {
        width: 300px;
      }
    }
  }
}
/*--------------------------------------------------------
！中間版！中間版！中間版！！577px~991px！！中間版！中間版！中間版！
---------------------------------------------------------*/
@media (min-width: 577px) and (max-width: 991px) {
  #Signature {
    h6 {
      padding: 20px;
    }
    p {
      text-align: center;
      margin-bottom: 25px;
    }
  }
}
/*--------------------------------------------------------
！電腦版！！電腦版！！電腦版！！大於992px~1199px！！電腦版！！電腦版！！電腦版！
---------------------------------------------------------*/
@media (min-width: 992px) and (max-width: 1199px) {
  #Signature {
    h6 {
      padding: 50px;
    }
    p {
      text-align: right;
      margin-right: 50px;
      margin-bottom: 25px;
    }
  }
}
/*--------------------------------------------------------
！螢幕版！！螢幕版！！螢幕版！！大於1200px！！螢幕版！！螢幕版！！螢幕版！
---------------------------------------------------------*/
@media screen and (min-width: 1200px) {
  #Signature {
    h6 {
      padding: 50px;
    }
    p {
      text-align: right;
      margin-right: 100px;
      margin-bottom: 25px;
    }
  }
}
</style>
